if (!customElements.get('engraving-modal')) {
  class EngravingModal extends HTMLElement {
    constructor() {
      super();
      this.modalEl = null;
      this.modalImageEl = null;
      this.modalCloseEl = null;
      this.modalBackdropEl = null;
    }

    connectedCallback() {
      this.modalEl = this.querySelector('#engraving-modal');
      this.modalImageEl = this.querySelector('#engraving-modal__image');
      this.modalCloseEl = this.querySelector('.engraving-modal__close');
      this.modalBackdropEl = this.querySelector('.engraving-modal__backdrop');

      if (!this.modalEl) return;

      this.attachEventListeners();
    }

    attachEventListeners() {
      document.addEventListener('click', this.handleTriggerClick.bind(this));
      
      this.modalCloseEl?.addEventListener('click', this.closeEngravingModal.bind(this));
      this.modalBackdropEl?.addEventListener('click', this.closeEngravingModal.bind(this));

      document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleTriggerClick(e) {
      if (e.target.closest('.engraving-zoom-trigger')) {
        e.preventDefault();
        const triggerEl = e.target.closest('.engraving-zoom-trigger');
        const imageSrc = triggerEl.dataset.engravingImage;
        const title = triggerEl.dataset.productTitle;
        
        if (imageSrc) {
          this.openEngravingModal(imageSrc, title);
        }
      }
    }

    handleKeydown(e) {
      if (e.key === 'Escape' && this.modalEl?.classList.contains('show')) {
        this.closeEngravingModal();
      }
    }

    openEngravingModal(imageSrc, title) {
      if (!this.modalEl || !this.modalImageEl) return;

      this.modalImageEl.src = imageSrc;
      
      this.modalEl.classList.remove('hidden');
      this.modalEl.classList.add('show');
      document.body.style.overflow = 'hidden';

      this.modalCloseEl?.focus();

      this.dispatchEvent(new CustomEvent('modal:opened', {
        detail: { imageSrc, title },
        bubbles: true
      }));
    }

    closeEngravingModal() {
      if (!this.modalEl) return;

      this.modalEl.classList.remove('show');
      this.modalEl.classList.add('hidden');
      document.body.style.overflow = '';

      this.dispatchEvent(new CustomEvent('modal:closed', {
        bubbles: true
      }));
    }

    open(imageSrc, title) {
      this.openEngravingModal(imageSrc, title);
    }

    close() {
      this.closeEngravingModal();
    }

    isOpen() {
      return this.modalEl?.classList.contains('show') || false;
    }
  }

  customElements.define('engraving-modal', EngravingModal);
}